import { NavLink } from 'react-router-dom';

// Area-switcher tabs for the consolidated Compliance section. The review queue
// (document-driven accept/reject/finalise workflow) and the KYC register
// (all-client status board + manual overrides + sanctions flag) now live under
// one "Compliance" nav item; this bar switches between them. Rendered at the top
// of both pages — NOT the per-client packet, which keeps its own back link.
//
// Uses the shared `.tabs` styling (button child inside NavLink, `.on` when
// active) — same pattern as the sidebar nav in PortalShell.
export function ComplianceTabs() {
  return (
    <div className="tabs" style={{ marginBottom: 20 }}>
      <NavLink to="/admin/compliance/register" style={{ textDecoration: 'none' }}>
        {({ isActive }) => (
          <button type="button" className={isActive ? 'on' : ''}>KYC register</button>
        )}
      </NavLink>
      <NavLink to="/admin/compliance/queue" style={{ textDecoration: 'none' }}>
        {({ isActive }) => (
          <button type="button" className={isActive ? 'on' : ''}>Review queue</button>
        )}
      </NavLink>
    </div>
  );
}
